// "use client";

// import { Breadcrumb, Tabs } from "antd";
// // import PagesForm from "./PagesForm";

// const AllPages = () => {
//     return (
//         <div className="w-full">
//             <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">Pages Banner</h1>
//             <div className="mb-4">
//                 <Breadcrumb
//                     separator=">"
//                     items={[{ title: "Dashboard" }, { title: "All Pages" }]}
//                     className="text-xs sm:text-base"
//                 />
//             </div>

//             {/* <Tabs
//                 defaultActiveKey="1"
//                 className="custom-tabs"
//                 items={[
//                     { key: "1", label: "About", children: <PagesForm pageType="ABOUT" /> },
//                     { key: "2", label: "Fillings", children: <PagesForm pageType="FILLING" /> },
//                     { key: "3", label: "Payments", children: <PagesForm pageType="PAYMENT" /> },
//                     { key: "4", label: "Profile", children: <PagesForm pageType="PROFILE" /> },
//                     { key: "5", label: "View Tax Summary", children: <PagesForm pageType="VIEW_TAX_SUMMARY" /> },
//                     { key: "6", label: "Booking", children: <PagesForm pageType="BOOKING_HISTORY" /> },
//                     { key: "7", label: "Track Fillings", children: <PagesForm pageType="TRACK_FILLING" /> },
//                     { key: "8", label: "Documents", children: <PagesForm pageType="DOCUMENT" /> },
//                     { key: "9", label: "Terms & Conditions", children: <PagesForm pageType="TERM_CONDITION" /> },
//                     { key: "10", label: "Privacy & Policy", children: <PagesForm pageType="PRIVACY_POLICY" /> },
//                     { key: "11", label: "Support & Help", children: <PagesForm pageType="SUPPORT_HELP" /> },
//                     { key: "12", label: "FAQs", children: <PagesForm pageType="FAQ" /> },
//                 ]}
//             /> */}
//         </div>
//     );
// };

// export default AllPages;





"use client";

import { Breadcrumb, Tabs } from "antd";
import PagesForm from "./PagesForm";
import { PageType } from "@src/types/api/pageBanner";
import { useState } from "react";

const tabs: { key: string; label: string; pageType: PageType }[] = [
  { key: "1", label: "Filling", pageType: "FILLING" },
  { key: "2", label: "Payment", pageType: "PAYMENT" },
  { key: "3", label: "Profile", pageType: "PROFILE" },
  { key: "4", label: "View Tax Summary", pageType: "VIEW_TAX_SUMMARY" },
  { key: "5", label: "Booking History", pageType: "BOOKING_HISTORY" },
  { key: "6", label: "Track Filling", pageType: "TRACK_FILLING" },
];

const AllPages = () => {

  const [activeKey, setActiveKey] = useState("1");

  const activeTab = tabs.find((tab) => tab.key === activeKey);

  return (
    <div className="w-full">
      <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">Pages Banner</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Banner" }, { title: activeTab?.label }]}
          className="text-xs sm:text-base"
        />
      </div>

      <Tabs
        defaultActiveKey="1"
        className="custom-tabs"
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
        items={tabs.map((tab) => ({
          key: tab.key,
          label: tab.label,
          children: <PagesForm pageType={tab.pageType} />,
        }))}
      />
    </div>
  );
};

export default AllPages;